import { render } from "./RiwayatPenjualan.vue?vue&type=template&id=aeb0d664"
import script from "./RiwayatPenjualan.vue?vue&type=script&lang=js"
export * from "./RiwayatPenjualan.vue?vue&type=script&lang=js"
script.render = render

export default script